import { useBucket } from '@mc/experiments-react'

import { CONCIERGE_EXPERIENCE_FLAG_NAME } from './constants'

export const useConciergeExperience = () => {
  const bucket = useBucket(CONCIERGE_EXPERIENCE_FLAG_NAME)

  return { isVariant: !!bucket?.includes('variant') }
}
